import React from "react";

function GridHighlight({ items, teasers, labels, columns, type }) {
  if (items.length === 0) {
    return (
      <div className={"no-results p-4 transition-none"}>
        {labels["nothing"]}
      </div>
    );
  }

  if (items.length === 1) {
    return (
      <div className="v-flex v-flex-col md:v-flex-row v-gap-8">
        <div
          className="v-w-full md:v-w-1/2"
          dangerouslySetInnerHTML={{
            __html: teasers[items[0].nid],
          }}
        ></div>
        <div className="v-flex v-flex-col v-items-center v-w-full md:v-w-1/2 v-justify-start v-gap-y-4"></div>
      </div>
    );
  }

  // if code gets here, items.length >= 2
  const big = items[0]; //get first item
  const small = items.slice(1, 3); //get second and third items

  if (items.length === 2 || items.length === 3) {
    return (
      <div className="v-flex v-flex-col md:v-flex-row v-gap-8">
        <div
          className="v-w-full md:v-w-1/2"
          dangerouslySetInnerHTML={{
            __html: teasers[items[0].nid],
          }}
        ></div>
        <div className="v-flex v-flex-col v-items-center v-w-full md:v-w-1/2 v-justify-start v-gap-y-4">
          {small.map((entity, index) => (
            <div
              className="v-w-full"
              key={index}
              dangerouslySetInnerHTML={{
                __html: teasers[entity.nid],
              }}
            />
          ))}
        </div>
      </div>
    );
  }

  // if code gets here, items.length >= 4
  const others = items.slice(3);

  return (
    <div className="v-flex v-flex-col">
      <div className="v-flex v-flex-col md:v-flex-row v-gap-8">
        <div
          className="v-w-full md:v-w-1/2"
          dangerouslySetInnerHTML={{
            __html: teasers[big.nid],
          }}
        ></div>

        <div className="v-flex v-flex-col v-items-center v-w-full md:v-w-1/2 v-justify-start v-gap-y-4">
          {small.map((entity, index) => (
            <div
              key={index}
              dangerouslySetInnerHTML={{
                __html: teasers[entity.nid],
              }}
            />
          ))}
        </div>
      </div>
      <div className="v-grid v-grid-cols-2 v-gap-8">
        {others.map((entity, index) => (
          <div
            key={index}
            dangerouslySetInnerHTML={{
              __html: teasers[entity.nid],
            }}
          />
        ))}
      </div>
    </div>
  );
}

export default GridHighlight;
